﻿package com.mgacreative.hotelru.domain.model

import kotlinx.serialization.Serializable

@Serializable
data class PosCategory(
    val id: String = "",
    val tenant_id: String = "",
    val name: String,
    val created_at: String = ""
)

